"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dam = void 0;
const Pond_1 = require("./Pond");
const typeName = 'Dam';
class Dam extends Pond_1.Pond {
    constructor(ob) {
        super({ ...ob, type: typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.Dam = Dam;
